// generated file, if you want to edit this file manually change the word "generated" to "manual"

import { isVariantEnabled, makeThemedStyles } from '@qpr/components/utils';
import clsx from 'clsx';
import React from 'react';

const useStylesForKPITableCell = makeThemedStyles('KPITable.KPITableRow.KPITableCell', () => ({
  KPITableCell: {
    display: 'table-cell',
    padding: '0.7em',
    paddingTop: '1em',
    paddingBottom: '1em',
    verticalAlign: 'middle'
  },

  center: {
    textAlign: 'center'
  }
}));

type ElementProps = React.ComponentProps<React.HTMLFactory<HTMLElementTagNameMap['div']>>;

export const KPITableCell: React.FunctionComponent<ElementProps> = (props: ElementProps) => {
  const styles = useStylesForKPITableCell();

  /* eslint-disable */
  return (
    <div
      {...props}
      style={{ ...(props?.style || {}), ...{} }}
      className={clsx(styles.KPITableCell, {
        [styles.center]: isVariantEnabled(props, 'center')
      })}
    >
      {props?.children}
    </div>
  );
};
export default KPITableCell;
